import { AvField, AvForm } from "availity-reactstrap-validation";
import React from "react";
import { Row, Col } from "reactstrap";

const AllVariantRows = (props) => {
  const {editPage, _id, onDelete, variantOptions, disabledDelete, onChange, data } = props;
  
  
  const handleInputChange = (e) => {
    const {name, value } = e.target;
    
    if(name.startsWith('attribute-')){
        var arr= name.trim().split("-");
        var obj={};
        obj.name=arr[1];
        obj.value=value;
        onChange(_id, "attributes", obj );
    }else{
        onChange(_id, name, value);
    }
 
  };


  return (
    <AvForm>
    <Row>
      <Col>
      
        <label className="form-label mt-3">SKU</label>
        <AvField
          value={data?.sku || ""}
          name="sku"
          className="form-control"
          type="text"
          placeholder="Enter SKU"
          onChange={handleInputChange}
          disabled={editPage}
          validate={{
            required: { value: true, errorMessage: "Please enter SKU" },
            pattern: {
              value: /^.{0,32}$/,
              errorMessage: "Maximum 32 characters allowed",
            },
          }}
        />
      </Col>
      <Col>
        <label className="form-label mt-3">Stock Quantity</label>
        <AvField
          name="inventory"
          value={data?.inventory || ""}
          className="form-control"
          type="text"
          placeholder="Enter Quantity"
          onChange={handleInputChange}
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter Stock Quantity",
            },
            min: {
              value: 1,
              errorMessage: "Minimum value is 1",
            },
            max: {
              value: 10000000,
              errorMessage: "Maximum value is 10000000",
            },
          }}
        />
      </Col>

      {variantOptions.map((option, idx) =>  (
       
        <Col key={option.id}>
          <div>
            <label className="col-form-label mt-2">
              {option.name !== null && option.name !== ""
                ? option.name
                : "Attribute"}
            </label>
            <AvField type="select"
            value={data?.attributes[idx]?.value}
            validate={{ required: { value: true } }}
            errorMessage="Please select valid option"
            onChange={handleInputChange}
            name={`attribute-${option.name}`} id={`attribute-${option.name}`} className="form-control">
            <option>Select</option>
              {option.chips ? (
                option.chips.map((chip) => (
                  <option key={chip} value={chip}>
                    {chip}
                  </option>
                ))
              ) : (
                <option>Value</option>
              )}
            </AvField>
          </div>
        </Col>
      ))}

      <Col>
        <label className="form-label mt-3">Cost Price</label>
        <AvField
          name="costPrice"
          value={data?.costPrice || ""}
          className="form-control"
          type="text"
          placeholder="Enter Price"
          onChange={handleInputChange}
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter Cost Price",
            },
            min: {
              value: 1,
              errorMessage: "Minimum value is 1",
            },
            max: {
              value: 10000000,
              errorMessage: "Maximum value is 10000000",
            },
          }}
        />
      </Col>
      <Col>
        <label className="form-label mt-3">Selling Price</label>
        <AvField
          name="sellingPrice"
          className="form-control"
          type="text"
          placeholder="Enter Price"
          value={data?.sellingPrice ||""}
          onChange={handleInputChange}
          validate={{
            required: {
              value: true,
              errorMessage: "Please enter Selling Price",
            },
            min: {
              value: 1,
              errorMessage: "Minimum value is 1",
            },
            max: {
              value: 10000000,
              errorMessage: "Maximum value is 10000000",
            },
          }}
        />
      </Col>
      <Col>
        <button
          type="button"
          className="btn btn-primary waves-effect waves-light mt-5"
          onClick={() => onDelete(_id)}
          disabled={disabledDelete}
        >
          <i className="mdi mdi-18px mdi-delete"></i>
        </button>
      </Col>
    </Row>
    </AvForm>
  );
};

export default AllVariantRows;